module.exports = __webpack_public_path__ + "img/beware.a43586bc.png";